module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-01-3adc9e3869afcd8bb592949f004dac72.webp";